import React, { useMemo } from "react";
import { ActStatusType } from "../../../../../API/teams";
import classNames from "classnames";
import Style from "./index.module.scss";

interface Props {
    actStatus: ActStatusType;
}
const Index = ({ actStatus }: Props) => {
    const data = useMemo(() => {
        switch (actStatus) {
            case ActStatusType.ToBeInvolved:
                return {
                    text: "待参与",
                    className: "ToBeInvolved"
                };
            case ActStatusType.ToBeSubmitted:
                return {
                    text: "待提交",
                    className: "ToBeSubmitted"
                };
            case ActStatusType.Submitted:
                return {
                    text: "已参与",
                    className: "Submitted"
                };
            default:
                return {
                    text: "NULL",
                    className: "Error"
                };
        }
    }, [actStatus]);
    return (
        <div className={classNames(Style.root, Style[data.className])}>
            {data.text}
        </div>
    );
};

export default Index;
